export const rusticiExportTypes = {
  SCORM12: "SCORM 1.2",
  SCORM20044THEDITION: "SCORM 2004 4th Edition",
  SCORM20043RDEDITION: "SCORM 2004 3rd Edition",
  AICC: "AICC",
  LTI: "LTI 1.1",
  LTI1P3: "LTI 1.3",
};
